<div
  [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">

  <div class="col-12" *ngIf="userProfile">
    <div class=" card card-user">
      <div class=" card-body" style="height:70vh;overflow: auto">

        <div class="row">
          <div class="col-12 col-md-4 text-center">

            <div class="mb-2 mx-auto imageFrame" [ngClass]="userProfile.isBlocked  ? 'red': 'green'">
              <a href="javascript:void(0)">
                <img
                  [src]="userProfile.profilePicture? userProfile.profilePicture: '../../../../assets/img/default-avatar.png'"
                  class="profileImage"> <br/>
              </a>
            </div>

            <h5 class="description"><i class="fa fa-user mx-2" aria-hidden="true"></i>{{this.userProfile.fullName}}
            </h5>
            <mat-slide-toggle [(ngModel)]="userProfile.isBlocked"
                              (change)="this.internalService.BlockUnBlock(userProfile.id, $event.checked === true ? true: false);">
            </mat-slide-toggle>
<!--                          <p class="description">Ceo/Co-Founder</p>-->
          </div>
          <div class="col-12 col-md-8 justify">

            <div class="row pt-4">
              <div class="col-12 col-md-6">
                <p><i class="fa fa-phone mx-2" aria-hidden="true"></i><span
                  class="ltr">{{this.userProfile.phoneNumber}}</span></p>
              </div>
              <div class="col-12 col-md-6">
                <p *ngIf="this.userProfile.province"><i class="fa fa-map-marker mx-2"
                                                        aria-hidden="true"></i>{{this.userProfile.province}}
                  &nbsp; {{this.userProfile.city}}</p>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-12 col-md-6">
                <p style="cursor: pointer" *ngIf="userProfile.idCardInfo && userProfile.idCardInfo.number"
                   (click)="showImage(this.userProfile.idCardInfo.imageIdCard)"><i class="fa fa-id-card-o"
                                                                                   aria-hidden="true"></i>&nbsp; <span
                  class="ltr"> {{this.userProfile.idCardInfo.number}}</span></p>

              </div>
              <div class="col-12 col-md-6" *ngIf="userProfile.idCardInfo">
                <p> {{'Users.VerificationStatus'|translate}}: {{this.userProfile.idCardInfo.status === 0 ?
                    ('Users.NotRequested'|translate) : this.userProfile.idCardInfo.status === 1
                        ? ('Users.Requested'|translate) : this.userProfile.idCardInfo.status === 2 ?
                            ('Users.RequestAccepted'|translate) : this.userProfile.idCardInfo.status === 3 ?
                                ('Users.RequestRejected'|translate) : null}}</p>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col-12">
                <div *ngIf="userProfile.roles"><i class="fa fa-users mx-2" aria-hidden="true"></i> &nbsp;&nbsp;<p
                  class="mx-2 d-inline-block" *ngFor="let role of this.userProfile.roles">{{'Menu.' + role|
                    translate}}</p>
                </div>
                <p class="pt-3"><span class="mx-2">{{'Users.Views'|translate}}</span>
                  &nbsp;{{this.userProfile.visit}}&nbsp;</p>

              </div>


            </div>

          </div>

        </div>
        <div class="row border-bottom mb-1">
          <div class="col-12 col-md-4 text-center" *ngIf="this.userProfile.isTechnician">
            <!--              <p class="title">{{'Users.IsTechnician' | translate}}</p>-->
            <ng-template #t let-fill="fill" class="mx-auto">
              <span class="star" [class.full]="fill === 100">
                <span class="half" [style.width.%]="fill">★</span>★
              </span>
            </ng-template>
            <ngb-rating
              [(rate)]="this.userProfile.technicnianInfo.ratingCount === 0 ? 0 : this.userProfile.technicnianInfo.rate"
              [starTemplate]="t" [readonly]="true" [max]="5"></ngb-rating>

          </div>
          <div class="col-12 col-md-8" *ngIf="this.userProfile.isTechnician">
            <p>{{'Users.BecomingTechnicianDate'|translate}}:
              &nbsp;&nbsp;{{(this.userProfile.technicnianInfo.dateBecomeTechnican| datePipe: 'true': 'fdt')}}
            </p>
            <p>
              {{'Users.TarrifExpirationDate'|translate}}
              :&nbsp;&nbsp;{{(this.userProfile.technicnianInfo.expireDate| datePipe: 'true': 'fdt')}}</p>
          </div>

        </div>
        <div class="row">
          <div class="col-12 col-md-4"></div>
          <div class="col-12 col-md-8">
            <p class="py-2" *ngIf="this.userProfile.isActive">
              {{'Users.Tarrif'|translate}}: &nbsp;&nbsp;{{this.userProfile.technicnianInfo.tariff}}
              &nbsp;&nbsp; {{this.userProfile.technicnianInfo.tariffLeftDays}} {{'Users.Days'|translate}}</p>

            <div class="py-2"
                 *ngIf="userProfile.technicnianInfo &&userProfile.technicnianInfo.skills &&userProfile.technicnianInfo.skills.length>0">
              <p>{{'Users.Skills'|translate}}:</p>


              <p class="mx-3" *ngFor="let item of this.userProfile.technicnianInfo.skills">- &nbsp;{{item.name}}: &nbsp;

                <span class="badge badge-info" *ngFor="let tag of item.tags">{{tag.title}}</span>
                <span *ngIf="item.tags.length===0">-</span>
                <br/>
              </p>

            </div>

          </div>

        </div>
        <div class="row border-bottom">

          <div class="col-12 col-md-4 text-center" *ngIf="this.internalService.sendMessageAccessFromProfile()">

            <button type="button" class="btn small-btn mt-1" (click)="this.isShow = true"
                    *ngIf="!isShow">{{'Button.SendMessage'|translate}}</button>
            <p class="my-3 mx-auto btn-outline-yellow" (click)="navigateToChat()" style="font-size: 0.8rem; ">{{'Users.ShowMessagesHistory'| translate}}</p>
          </div>
          <div class="col-12 col-md-8">
            <div *ngIf="isShow"
                 [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
              <label>{{'Button.MessageContent'|translate}}</label><br/>
              <textarea rows="3" cols="50" [(ngModel)]="Message"></textarea>
              <br/>
              <div class="row d-flex justify-content-end px-5">
                <button type="button" class="btn small-btn"
                        (click)="sendMessage(this.userProfile.id)">{{'Button.Send'|translate}}</button>
              </div>

            </div>
          </div>


        </div>

        <div class="row col-12" *ngIf="this.userProfile.isTechnician" style="padding: 10px;">
          <div class="col-6">
            <p> {{'Users.IdCard'|translate}} </p>
            <img [src]="this.userProfile.technicnianInfo.idCard.image" width="100px" height="100px" alt="">
          </div>
          <div class="col-6">
            <p> {{'Users.License'|translate}} </p>
            <div *ngFor="let img of this.userProfile.technicnianInfo.licenses" >
              <img [src]="img.imageMD5" width="100px" height="100px" alt="">
            </div>
          </div>
        </div>

      </div>
      <div class=" card-footer">

      </div>
    </div>

  </div>

</div>
<div mat-dialog-actions>
  <button type="button" class="btn btn-outline-dark mb-3"
          [mat-dialog-close]="true">{{'Button.Close'|translate}}</button>
  <!--  <button mat-button cdkFocusInitial>Save</button>-->
</div>
